import { render, staticRenderFns } from "./ModeStudent.vue?vue&type=template&id=69e9c584&scoped=true&lang=pug&"
import script from "./ModeStudent.vue?vue&type=script&lang=ts&"
export * from "./ModeStudent.vue?vue&type=script&lang=ts&"
import style0 from "./ModeStudent.vue?vue&type=style&index=0&id=69e9c584&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e9c584",
  null
  
)

export default component.exports